import React from 'react'
import { Pagination } from 'react-bootstrap'

const Page = ({ page, currentPage, onSetPage }) => (
    <Pagination.Item active={currentPage === page} onClick={() => onSetPage(page)} >{page}</Pagination.Item> 
)

export default Page